(function () {
	window.addEventListener('DOMContentLoaded', () => {
		let init = false;
		
		/* Which media query */
		function swiperModel(elem) {
				let flkty = new Flickity(elem, { lazyLoad: true, pageDots: false });
			
				let mobile = window.matchMedia('(min-width: 0px) and (max-width: 989px)');
				let desktop = window.matchMedia('(min-width: 990px)');

				// Enable (for mobile)
				if(mobile.matches) {
					if (!init) { init = true; }
				}
	
				// Disable (for desktop)
				else if(desktop.matches) {
					flkty.destroy();
					init = false;
				}
		}

		function qsa(selector, parent = document) {
			return [...parent.querySelectorAll(selector)];
		}
	
		/* On Load */
		window.addEventListener('load', function() {
			let newsCarousels = qsa('.js-news-carousel');
			let collectionArchive = qsa('.js-collection-archive__row');

			Array.prototype.forEach.call(newsCarousels, function(carousel) {
				swiperModel(carousel);
			})

			Array.prototype.forEach.call(collectionArchive, function(carousel) {
				swiperModel(carousel);
			})
		});
	
		/* On Resize */
		window.addEventListener('resize', function() {
			let newsCarousels = qsa('.js-news-carousel');
			let collectionArchive = qsa('.js-collection-archive__row');

			Array.prototype.forEach.call(newsCarousels, function(carousel) {
				swiperModel(carousel);
			})

			Array.prototype.forEach.call(collectionArchive, function(carousel) {
				swiperModel(carousel);
			})
		});
	})
})();
